import type { HapticPattern } from '@hoedokloop/platform-ports';

export type JuiceCue = 'save.success' | 'success.major' | 'stamp.collect' | 'timer.done';

export type JuiceAsset = 'vivid.collect' | 'vivid.milestone';

export const JUICE_MUTED_KEY = 'juice.muted';
export const JUICE_VOLUME = 0.4;
export const JUICE_COOLDOWN_MS = 150;

export const JUICE_ASSET_URLS: Readonly<Record<JuiceAsset, string>> = {
  'vivid.collect': '/audio/vivid-collect.mp3',
  'vivid.milestone': '/audio/vivid-milestone.mp3',
};

export const JUICE_ASSET_DURATION_MS: Readonly<Record<JuiceAsset, number>> = {
  'vivid.collect': 300,
  'vivid.milestone': 800,
};

export const JUICE_CUE_DURATION_MS: Readonly<Record<JuiceCue, number>> = {
  'save.success': 300,
  'success.major': 800,
  'stamp.collect': 300,
  'timer.done': 800,
};

export const juiceAssetForCue: Readonly<Record<JuiceCue, JuiceAsset>> = {
  'save.success': 'vivid.collect',
  'success.major': 'vivid.milestone',
  'stamp.collect': 'vivid.collect',
  'timer.done': 'vivid.milestone',
};

export const hapticForCue: Readonly<Record<JuiceCue, HapticPattern>> = {
  'save.success': 'light',
  'success.major': 'success',
  'stamp.collect': 'success',
  'timer.done': 'medium',
};

function storedMutedValue(): string | null {
  try {
    return globalThis.localStorage?.getItem(JUICE_MUTED_KEY) ?? null;
  } catch {
    return null;
  }
}

export function isJuiceMuted(raw = storedMutedValue()): boolean {
  return raw === 'true';
}

export function setJuiceMuted(muted: boolean): void {
  try {
    globalThis.localStorage?.setItem(JUICE_MUTED_KEY, String(muted));
  } catch {
    // Private browsing may deny persistence; the in-memory setting still applies.
  }
}

export function isSilentJuiceRoute(pathname = globalThis.location?.pathname ?? ''): boolean {
  return pathname === '/rooms' || pathname.startsWith('/rooms/');
}

export function seoulDay(at = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(at);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? '00';
  return `${value('year')}-${value('month')}-${value('day')}`;
}

export function cueDurationMs(cue: JuiceCue): number {
  return JUICE_CUE_DURATION_MS[cue];
}
